// removed by extract-text-webpack-plugin
module.exports = {"classWithSticky":"WithSticky-classWithSticky-caeb9005","bottom":"WithSticky-bottom-2bf9418e","top":"WithSticky-top-0366ffb6"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/WithSticky.scss
// module id = 898
// module chunks = 0